import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// App-level redirect: the platform cannot 301 the default *.emergent.host URL,
// so we redirect visitors of the old production host to the custom domain.
// Only triggers on the exact production host — never on preview, localhost or the custom domain.
const OLD_PROD_HOST = "appart-booking-th.emergent.host";
const NEW_DOMAIN = "https://ng-residence.com";
if (typeof window !== "undefined" && window.location.hostname === OLD_PROD_HOST) {
  window.location.replace(NEW_DOMAIN + window.location.pathname + window.location.search + window.location.hash);
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
